import { BorderRadiusAll } from '../themes/default/borderRadius/index.js';
import { themeBorderRadius } from './borderRadius/utils.js';
import { BorderWidthAll } from '../themes/default/borderWidth/index.js';
import { themeBorderWidth } from './borderWidth/utils.js';
import { ColorAll } from '../themes/default/color/index.js';
import { themeColors } from './colors/utils.js';
import { iconsDefaultValues } from './icons/constants.js';
import { themeIcons } from './icons/utils.js';
import { logoDefaultValues } from './logo/constants.js';
import { themeLogo } from './logo/utils.js';
import { ShapeAll } from '../themes/default/shape/index.js';
import { themeShape } from './shape/utils.js';
import { SizeAll } from '../themes/default/size/index.js';
import { themeSize } from './size/utils.js';
import { SpacingAll } from '../themes/default/spacing/index.js';
import { themeSpacing } from './spacing/utils.js';
import { typographyDefaultValues } from './typography/constants.js';
import { themeTypography } from './typography/utils.js';
import React from 'react';
import { modalDefaultValues } from './modal/constants.js';
import { sidesheetDefaultValues } from './sidesheet/constants.js';
import { popoverDefaultValues } from './popover/constants.js';
import { themeUpdate } from './utils.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Theming Exports
var DoorDashTheme = {
  BorderRadius: BorderRadiusAll,
  BorderWidth: BorderWidthAll,
  Colors: ColorAll,
  Icons: iconsDefaultValues,
  Logo: logoDefaultValues,
  Modal: modalDefaultValues,
  Popover: popoverDefaultValues,
  Shape: ShapeAll,
  Sidesheet: sidesheetDefaultValues,
  Size: SizeAll,
  Spacing: SpacingAll,
  Typography: typographyDefaultValues
};
var ThemingContext = /*#__PURE__*/React.createContext(DoorDashTheme);

var Theming = function Theming(_ref) {
  var children = _ref.children,
      overrides = _ref.overrides;
  return /*#__PURE__*/React.createElement(ThemingContext.Provider, {
    value: {
      BorderRadius: themeBorderRadius(overrides && overrides.BorderRadius),
      BorderWidth: themeBorderWidth(overrides && overrides.BorderWidth),
      Colors: themeColors(overrides && overrides.Colors),
      Icons: themeIcons(overrides && overrides.Icons),
      Logo: themeLogo(overrides && overrides.Logo),
      Modal: themeUpdate(modalDefaultValues, overrides && overrides.Modal),
      Popover: themeUpdate(popoverDefaultValues, overrides && overrides.Popover),
      Shape: themeShape(overrides && overrides.Shape),
      Sidesheet: themeUpdate(sidesheetDefaultValues, overrides && overrides.Sidesheet),
      Size: themeSize(overrides && overrides.Size),
      Spacing: themeSpacing(overrides && overrides.Spacing),
      Typography: themeTypography(overrides && overrides.Typography)
    }
  }, children);
};

var ThemingConsumer = function ThemingConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(ThemingContext.Consumer, null, children);
};

var withTheming = function withTheming(Comp) {
  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    var theme = React.useContext(ThemingContext);
    return /*#__PURE__*/React.createElement(Comp, _extends({
      ref: ref,
      theme: theme
    }, props));
  });
};

export { DoorDashTheme, Theming, ThemingConsumer, ThemingContext, withTheming };
